import {getTrackingIdEndpoint} from './getEndpoints';
import Environment from '../constants/Environment';

const EXPIRATION_TIME_IN_DAYS = 365;
const COOKIE_NAME = 'tid';

const trackingCookie = {
  get: (): string => {
    const nameKey = `${COOKIE_NAME}=`;
    const cookiesList = typeof document === 'undefined' ? [] : document.cookie.split(';');

    for (let i = 0; i < cookiesList.length; i++) {
      let cookie = cookiesList[i];

      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }

      if (cookie.indexOf(nameKey) === 0) {
        return cookie.substring(nameKey.length, cookie.length);
      }
    }

    return '';
  },

  set: (providedEnv?: Environment): Promise<string> => {
    return fetch(getTrackingIdEndpoint(providedEnv), {
      credentials: 'include',
    })
      .then(response => response.json())
      .then(json => {
        const date = new Date();
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * EXPIRATION_TIME_IN_DAYS);

        const trackingProperty = `${COOKIE_NAME}=${json.tid}`;
        const expirationProperty = `expires=${date.toUTCString()}`;
        const pathProperty = `path=/`;

        if (typeof document !== 'undefined') {
          document.cookie = `${trackingProperty};${expirationProperty};${pathProperty}`;
        }

        return json.tid;
      });
  },
};

export default trackingCookie;
